/** @format */

import { Box, Stack, Typography } from "@mui/material";
import PropTypes from "prop-types";
import { LogoHonda } from "src/components/logos/logo-honda";
import { LogoHuyndai } from "src/components/logos/logo-huyndai";
import { LogoKia } from "src/components/logos/logo-kia";
import { LogoToyota } from "src/components/logos/logo-toyota";
import { RouterLink } from "src/components/router-link";
import { paths } from "src/paths";

export const Layout = (props) => {
  const { children } = props;

  return (
    <Box
      sx={{
        backgroundColor: "background.default",
        display: "flex",
        flex: "1 1 auto",
        flexDirection: "row",
      }}
    >
      <Box
        sx={{
          backgroundColor: "background.paper",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "top center",
          backgroundImage: 'url("/assets/gradient-bg.svg")',
          display: "flex",

          flex: 1,
          flexDirection: "column",
          justifyContent: "center",

          alignItems: { xs: "center", lg: "flex-end" },
          maxWidth: "100%",
          p: {
            xs: 4,
            md: 8,
          },

          " >div": {
            width: "100%",
            maxWidth: "420px",
          },
        }}
      >
        <div>
          <Box sx={{ mb: 4 }}>
            <Stack
              alignItems='center'
              component={RouterLink}
              direction='row'
              display='inline-flex'
              href={paths.index}
              spacing={1}
              sx={{ textDecoration: "none" }}
            >
              <Box
                sx={{
                  display: "inline-flex",
                  height: 80,
                }}
              >
                <img src={`/assets/logo.png`} />
              </Box>
            </Stack>
          </Box>
          {children}
        </div>
      </Box>
      <Box
        sx={{
          position: "relative",
          width: "100%",
          height: "100%",

          alignItems: "center",
          backgroundColor: "neutral.800",
          backgroundImage: 'url("/assets/gradient-bg.svg")',
          backgroundPosition: "top center",
          backgroundRepeat: "no-repeat",
          color: "common.white",
          display: { xs: "none", lg: "flex" },
          flex: 1,

          justifyContent: "center",
          p: {
            xs: 4,
            md: 8,
          },
        }}
      >
        <Box maxWidth='md'>
          <Typography sx={{ mb: 1 }} variant='h4'>
            NHIEUXE.VN
          </Typography>
          <Typography color='text.secondary' sx={{ mb: 4 }}>
            Cho thuê xe du lịch tại TPHCM và các tỉnh Miền Nam
          </Typography>

          <Typography variant='subtitle2' sx={{ mb: 2 }}>
            Địa chỉ: 226/51 An Dương Vương, phường 16, quận 8, TP HCM
          </Typography>
          <Typography variant='subtitle2' sx={{ mb: 2 }}>
            Hotline:0917879235 - 0977734334
          </Typography>
          <Typography variant='subtitle2' sx={{ mb: 2 }}>
            Email: nhieuxe@gmail.com
          </Typography>
          <Typography variant='subtitle2' sx={{ mb: 2 }}>
            Website: www.nhieuxe.vn
          </Typography>
        </Box>
        <Stack
          alignItems='center'
          direction='row'
          flexWrap='wrap'
          position='absolute'
          bottom={80}
          gap={4}
          sx={{
            color: "text.primary",
            "& > *": {
              color: "neutral.400",
              flex: "0 0 auto",
            },
          }}
        >
          <LogoHonda />
          <LogoHuyndai />
          <LogoToyota />
          <LogoKia />
        </Stack>
      </Box>
    </Box>
  );
};

Layout.propTypes = {
  children: PropTypes.node,
};
